import {
  localStorageGet,
  localStorageSet,
} from '@aboutyou/legacy-shared/src/utils/storage/localStorage'

export const readStorageValue = <T>(key: string, fallback: T) => {
  try {
    const readValue = localStorageGet(key)
    return readValue || fallback
  } catch (e) {
    return fallback
  }
}

export const writeStorageValue = (key: string, value: unknown) => {
  localStorageSet({ key, data: value })
}
